export default "__VITE_ASSET__Bl6VR482__"